import { render } from "./getPassInTable.vue?vue&type=template&id=52e95362&scoped=true"
import script from "./getPassInTable.vue?vue&type=script&lang=js"
export * from "./getPassInTable.vue?vue&type=script&lang=js"

import "./getPassInTable.vue?vue&type=style&index=0&id=52e95362&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e95362"]])

export default __exports__